import React from 'react';
import { Reveal } from './Reveal';
export function Mirror() {
  return <section id="espejo" className="scroll-mt-4 bg-ink px-6 py-24 text-center" data-id="element-85" data-mp="2nsb4qizhqeiq">
      <Reveal data-id="element-86" data-mp="2nue43tmj9k04">
        <h2 className="font-serif text-[36px] font-bold leading-tight text-white" data-id="element-87" data-mp="293ezsusqdhmc">Llegas sola. Otra vez.</h2>
        <div className="mt-10 space-y-6 text-[17px] leading-relaxed text-muted" data-id="element-88" data-mp="2e28bqisdd0ke">
          <p data-id="element-89" data-mp="2e05b74tlbp1f">Preparada. Exitosa. Un 10/10 en todo — menos en esto.</p>
          <p data-id="element-90" data-mp="31slypuw3k984">No es que te falte algo.</p>
          <p className="font-bold text-gold" data-id="element-91" data-mp="36qvrjyucmxqk">Es que nadie te enseñó a ver tu propio patrón.</p>
        </div>
        <blockquote className="mt-12 border-l-[3px] border-gold bg-panel px-6 py-6 text-left text-base leading-relaxed text-white" data-id="element-92" data-mp="2ru4ye7b9qi9e">
          El 1 de octubre, en el diagnóstico en vivo, Beatriz le pone nombre a ese patrón. Y te muestra por qué
          se puede reeducar.
        </blockquote>
      </Reveal>
    </section>;
}